<template>
    <div class="demo-page-container">
        <!-- 列表搜索过滤 -->
        <el-row :gutter="24">
            <div style="margin-top: 20px;margin-left: 20px">
                <div class="search-wrap">
                    <el-form
                        :label-position="'left'"
                        :model="searchForm"
                        ref="searchForm"
                        class="leader-style-form"
                        :inline="true"
                    >
                        <el-form-item label="公司名" label-width="50px" prop="name">
                            <el-input
                                placeholder="请输入公司名"
                                type="text"
                                class="em_inpunt"
                                oninput="if(value.length>50)value=value.slice(0,50)"
                                clearable
                                v-model="searchForm.elec_customer_name"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="户号" label-width="50px" prop="name">
                            <el-input
                                placeholder="请输入户号"
                                oninput="value=value.replace(/[^\d]/g,'')"
                                maxlength="20"
                                class="em_inpunt"
                                clearable
                                v-model="searchForm.account_num"
                            ></el-input>
                        </el-form-item>

                        <div style="float: right">
                            <el-button
                                size="medium"
                                type="warning"
                                @click="handleFilterList('1')"
                            >检索</el-button>
                            <el-button size="medium" type="danger" @click="handleFilterList('0')">清空</el-button>
                            <el-button
                                type="primary"
                                @click="handleEditInfo({}, '新增')"
                                size="medium"
                            >新增</el-button>
                        </div>
                    </el-form>
                </div>
            </div>
        </el-row>

        <div class="table-wrap">
            <el-table
                border
                :data="tableList"
                highlight-current-row
                class="leader-style-table"
                height="90%"
            >
                <el-table-column width="50" align="center" label="序号">
                    <template slot-scope="scope">
                        <span>
                            {{
                                (pageNum - 1) * pageSize + scope.$index + 1
                            }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="公司名" property="elec_customer_name" align="center"></el-table-column>
                <el-table-column label="户号" property="account_num" align="center"></el-table-column>
                <el-table-column label="户号名" property="account_name" align="center"></el-table-column>
                <el-table-column label="电价名称" property="price_name" align="center"></el-table-column>
                <el-table-column label="抄表例日" property="read_case_day" align="center"></el-table-column>
                <el-table-column label="操作" align="center" width="210">
                    <template slot-scope="scope">
                        <div class="color-blue">
                            <el-button
                                type="text"
                                class="button-custom"
                                @click="checkCapacity(scope.row)"
                            >容量</el-button>
                            <div class="split-line"></div>
                            <el-button
                                type="text"
                                class="button-modify"
                                @click="handleEditInfo(scope.row, '修改')"
                            >修改</el-button>
                            <div class="split-line"></div>
                            <el-button
                                type="text"
                                class="button-delete"
                                @click="hanleDelInfo(scope.row)"
                            >删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                class="leader-style-pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
            ></el-pagination>
        </div>
        <!-- 列表 -->

        <!-- 新增、修改、查看 -->
        <el-dialog
            :title="dialogTitle"
            width="650px"
            class="leader-dialog"
            :visible.sync="dialogStatus"
            @close="closeDiaCb"
             v-loading="Loading"
            :close-on-click-modal="dialogTitle !== '查看' ? false : true"
        >
            <div class="plan-dialog-wrap">
                <el-form
                    :model="inputDetail"
                    ref="inputDetail"
                    label-width="160px"
                    :rules="inputRule"
                    class="leader-style-form"
                >
                    <el-form-item label="户号" prop="account_num">
                        <el-input
                            maxlength="50"
                            placeholder="请输入户号"
                            :disabled="dialogTitle === '查看'"
                            v-model="inputDetail.account_num"
                            autocomplete="off"
                            show-word-limit
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="户号名" prop="account_name">
                        <el-input
                            type="text"
                            maxlength="20"
                            placeholder="请输入户号名"
                            :disabled="dialogTitle === '查看'"
                            v-model="inputDetail.account_name"
                            autocomplete="off"
                            show-word-limit
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="电压等级" prop="voltage_grade">
                        <el-select
                            v-model="inputDetail.voltage_grade"
                            :disabled="dialogTitle === '查看'"
                            class="txt_select"
                        >
                            <el-option
                                v-for="item in voltageGradeList"
                                :key="item.code_value"
                                :label="item.code_name"
                                :value="item.code_value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="电价名称" prop="pub_area_catalog_id">
                        <el-select
                            v-model="inputDetail.pub_area_catalog_id"
                            :disabled="dialogTitle === '查看'"
                            class="txt_select"
                        >
                            <el-option
                                v-for="item in priceNameList"
                                :key="item.pub_area_catalog_id"
                                :label="item.price_name"
                                :value="item.pub_area_catalog_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属公司" prop="elec_customer_id">
                        <el-select
                            v-model="inputDetail.elec_customer_id"
                            :disabled="dialogTitle === '查看'"
                            @change="
                                getPointsList(inputDetail.elec_customer_id)
                            "
                            class="txt_select"
                        >
                            <el-option
                                v-for="item in customerList"
                                :key="item.elec_customer_id"
                                :label="item.cust_name"
                                :value="item.elec_customer_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="采集点" prop="point_ids" 
                        v-loading="pointLoading"
                        element-loading-text="加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)">
                        <el-select v-model="inputDetail.point_ids" filterable placeholder="请选择采集点"
                            @focus="doCheckCustomer()">
                            <el-option
                                style="width: 300px"
                                v-for="item in pointList"
                                :key="item.point_id"
                                :label="item.point_name"
                                :value="item.point_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="计算方式" prop="is_read_case">
                        <el-select
                            v-model="inputDetail.is_read_case"
                            :disabled="dialogTitle === '查看'"
                            class="txt_select"
                        >
                            <el-option
                                v-for="item in typeList"
                                :key="item.code_value"
                                :label="item.code_name"
                                :value="item.code_value"
                            ></el-option>
                        </el-select>      
                    </el-form-item>
                    <el-form-item
                        v-if="inputDetail.is_read_case === '1'"
                        label="抄表例日"
                        prop="read_case_day"
                    >
                        <el-select
                            v-model="inputDetail.read_case_day"
                            :disabled="dialogTitle === '查看'"
                            class="txt_select"
                        >
                            <el-option
                                v-for="item in read_case_dayList"
                                :key="item.code_value"
                                :label="item.code_name"
                                :value="item.code_value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button
                    v-if="dialogTitle !== '查看'"
                    @click="saveUserInfo('')"
                    class="leader-common-button"
                >保存</el-button>
                <el-button @click="dialogStatus = false" class="leader-common-button">取消</el-button>
            </div>
        </el-dialog>

        <!-- 新增容量弹窗 -->
        <el-dialog
            title="容量"
            width="80%"
            :visible.sync="deviceDiaStatus"
            @close="closedeviceDiaCallback"
            :close-on-click-modal="true"
            class="leader-dialog"
        >
            <el-button @click="addDeviceRow" style="float: right;" class="leader-common-button">新增</el-button>

            <el-form :rules="model.rules" :model="model" ref="form" class="leader-style-form">
                <!-- 表布局 -->
                <el-table
                    border
                    :data="model.capacityList"
                    style="width: 100%;"
                    class="leader-style-table"
                    :default-sort="{ prop: 'date', order: 'descending' }"
                >
                    <el-table-column
                        type="index"
                        width="50"
                        align="center"
                        label="序号"
                        property="num"
                    ></el-table-column>

                    <el-table-column label="开始时间">
                        <template slot-scope="scope">
                            <el-form-item
                                :prop="
                                    'capacityList.' +
                                    scope.$index +
                                    '.from_date'
                                "
                                :rules="model.rules.from_date"
                            >
                                <el-date-picker
                                    v-model="scope.row.from_date"
                                    type="month"
                                    format="yyyy-MM"
                                    value-format="yyyy-MM"
                                    placeholder="选择日期"
                                ></el-date-picker>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="结束时间">
                        <template slot-scope="scope">
                            <el-form-item
                                :prop="
                                    'capacityList.' + scope.$index + '.to_date'
                                "
                                :rules="model.rules.to_date"
                            >
                                <el-date-picker
                                    v-model="scope.row.to_date"
                                    type="month"
                                    format="yyyy-MM"
                                    value-format="yyyy-MM"
                                    placeholder="选择日期"
                                ></el-date-picker>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="容量">
                        <template slot-scope="scope">
                            <el-form-item
                                :prop="
                                    'capacityList.' + scope.$index + '.capacity'
                                "
                                :rules="model.rules.capacity"
                            >
                                <el-input
                                    v-model="scope.row.capacity"
                                    maxlength="12"
                                    oninput="value=value.replace(/[^0-9]/g,'')"
                                ></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button
                                @click="delDeviceInfo(scope.row)"
                                class="leader-common-button"
                            >删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button class="leader-common-button" @click="save()">保存</el-button>
                <el-button class="leader-common-button" @click="deviceDiaStatus = false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import * as api from "@/http/api-zmy.js";
import dayjs from "dayjs";
import util from "@/utils/util";
export default {
    data() {
        return {
            tableList: [], //列表list
            priceNameList: [], //电价列表集合
            pointList: [], //采集点集合
            pointLoading: false,
            customerList: [], //公司集合
            voltageGradeList: [], //电压等级集合
            read_case_dayList: [], //抄表例日集合
            typeList: [
                {
                    code_value: "0",
                    code_name: "按自然月计算"
                }
                // {
                //     code_value: "1",
                //     code_name: "按抄表例日计算"
                // }
            ], //计算方式列表list
            pageNum: 1, //页码
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            totalNum: 0, //总条数
            // account_num:0,
            // elec_customer_name:'',
            loading: false, //loading状态
            dialogTitle: "新增", //弹窗title
            dialogStatus: false, //弹窗关闭状态
            diaLoading: false, //弹窗loading状态
            deviceDiaStatus: false,
            deviceDiaLoading: false,
            elec_customer_account_id: "",
            dialogStatusPoint: false, //弹窗关闭状态
            // checkedCities: "",
            // cities: [],
            chooseRow: {}, //被选择的行数据
            searchForm: {
                //筛选form
                account_num: "",
                elec_customer_name: ""
            },

            inputDetail: {
                account_num: "",
                account_name: "",
                voltage_grade: "",
                point_ids: "",
                is_read_case: "",
                read_case_day: "",
                elec_customer_id: "",
                pub_area_catalog_id: ""
            },
            inputRule: {
                account_num: [
                    {
                        required: true,
                        message: "户号不能为空",
                        trigger: "blur"
                    },
                    { validator: this.$cv.numberValidator, trigger: 'blur' }
                ],
                account_name: [
                    {
                        required: true,
                        message: "户号名不能为空",
                        trigger: "blur"
                    }
                ],
                voltage_grade: [
                    {
                        required: true,
                        message: "请选择电压等级",
                        trigger: "change"
                    }
                ],
                pub_area_catalog_id: [
                    {
                        required: true,
                        message: "请选择电价名称",
                        trigger: "change"
                    }
                ],
                elec_customer_id: [
                    {
                        required: true,
                        message: "请选择所属公司",
                        trigger: "change"
                    }
                ],
                // point_ids: [
                //     {
                //         required: true,
                //         message: '请选择采集点',
                //         trigger: 'blur'
                //     }
                // ],
                is_read_case: [
                    {
                        required: true,
                        message: "请选择是否按抄表例日计算",
                        trigger: "change"
                    }
                ],
                read_case_day: [
                    {
                        required: true,
                        message: "请选择抄表例日",
                        trigger: "blur"
                    }
                ]
            },
            inputFormRule: {
                from_date: [
                    {
                        required: true,
                        message: "请选择开始日期",
                        trigger: "blur"
                    }
                ],
                to_date: [
                    {
                        required: true,
                        message: "请选择结束日期",
                        trigger: "blur"
                    }
                ],
                capacity: [
                    {
                        required: true,
                        message: "请选择容量",
                        trigger: "blur"
                    }
                ]
            },
            form: {
                from_date: "",
                to_date: "",
                capacity: ""
            },
            model: {
                rules: {
                    from_date: {
                        required: true,
                        message: "请选择开始日期",
                        trigger: "change"
                    },
                    to_date: {
                        required: true,
                        message: "请选择结束日期",
                        trigger: "change"
                    },
                    capacity: {
                     //   type: "string",
                        required: true,
                        message: "请输入容量",
                        trigger: "change"
                    }
                },
                capacityList: [
                    {
                        from_date: "",
                        to_date: "",
                        capacity: ""
                    }
                ]
            }
        };
    },
    created() {
        this.getAccountList();
        this.getPriceNamelist();
        this.getCustomerList();
        // this.getPointsList(this.inputDetail.elec_customer_id);
        this.getCodelistByKind("voltage_grade");
        this.getCodelistByKind("read_case_day");
    },
    methods: {
        /**
         * 对话框保存
         * */
        save(str) {
            this.$refs["form"].validate((valid, model) => {
                if (valid) {
                    api.capacityFormSave({
                        elec_customer_account_id: this.elec_customer_account_id,
                        list: this.model.capacityList
                    }).then(res => {
                        if (res && res.error_code === "0") {
                            this.$message({
                                type: "success",
                                message: res.error_msg
                            });
                            this.deviceDiaStatus = false;
                        }
                        this.loading = false;
                    });
                }
            });
        },

        /**
         * 获取电价名称列表
         */
        getPriceNamelist() {
            api.getPriceNamelist({
                // code_kind: 'demo_user_type'
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.priceNameList = res.bus_json;
                }
            });
        },
        /**
         * 获取采集点列表
         */
        async getPointsList(str) {
            this.pointLoading = true;
            this.inputDetail.point_ids = "";
            await api.getPointsList({
                elec_customer_id: str, //客户id
                p_point_id: "" //父节点id
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.pointList = res.bus_json;
                }
                this.pointLoading = false;
            });
        },
        doCheckCustomer() {
            if(!this.inputDetail.elec_customer_id) {
                this.$message({
                    type: 'info',
                    message: '请先选择所属公司'
                });
            }
        },
        /**
         * 获取公司列表
         */
        getCustomerList() {
            api.getCustomerList({}).then(res => {
                if (res && res.error_code === "0") {
                    this.customerList = res.bus_json;
                }
            });
        },
        /**
         * 获取电价等级列表
         * voltage_grade电压等级
         * read_case_day抄表例日
         */
        getCodelistByKind(str) {
            api.getCodelistByKind({
                code_kind: str
            }).then(res => {
                if (str === "voltage_grade") {
                    if (res && res.error_code === "0") {
                        this.voltageGradeList = res.bus_json[0].codelists;
                    }
                } else {
                    if (res && res.error_code === "0") {
                        this.read_case_dayList = res.bus_json[0].codelists;
                    }
                }
            });
        },
        /**
         * 列表条数改变回调
         */
        handleSizeChange(e) {
            this.pageNum = 1;
            this.pageSize = e;
            this.getAccountList();
        },
        /**
         * 企业列表页码改变回调
         */
        handleCurrentChange(e) {
            this.pageNum = e;
            this.getAccountList();
        },
        /**
         * 获取demo列表
         */
        getAccountList() {
            this.loading = true;
            api.getAccountList({
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                account_num: this.searchForm.account_num,
                elec_customer_name: this.searchForm.elec_customer_name
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.totalNum = res.bus_json.totalNum;
                    this.tableList = res.bus_json.items;
                }
                this.loading = false;
            });
        },

        /**
         * 筛选列表
         */
        handleFilterList(flag) {
            if (flag === "0") {
                this.searchForm.account_num = "";
                this.searchForm.elec_customer_name = "";
            }
            this.pageNum = 1;
            this.getAccountList();
        },
        /**
         * 关闭弹窗回调函数
         */
        closeDiaCb() {
            this.$refs.inputDetail.resetFields();
            this.inputDetail.elec_customer_account_id = "";
        },
        /**
         * 查看容量列表
         */
        checkCapacity(row) {
            this.model.capacityList=[];
            this.deviceDiaStatus = true;
            this.elec_customer_account_id = row.elec_customer_account_id;
            this.getCapacitylist(row);
        },
        /**
         * 点击新增、查看、修改按钮：
         * params {row<object>} 行数据
         * params {type<string>} 类型：type 新增，查看，删除
         */
        async handleEditInfo(row, type) {
            this.pointList = [];
            // this.inputDetail.point_ids = "";
            if (type !== "新增") {
                this.diaLoading = true;
                this.chooseRow = row;
                await this.getPointsList(row.elec_customer_id);
                this.getDetailInfo(row);
            }
            this.dialogTitle = type;
            this.dialogStatus = true;
        },
        /**
         * 获取查看信息
         */
        getDetailInfo(row) {
            api.getInfoById({
                elec_customer_account_id: row.elec_customer_account_id
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.inputDetail.account_num = res.bus_json.account_num;
                    this.inputDetail.account_name = res.bus_json.account_name;
                    this.inputDetail.point_ids = res.bus_json.point_ids;
                    this.inputDetail.voltage_grade = res.bus_json.voltage_grade;
                    this.inputDetail.pub_area_catalog_id =
                        res.bus_json.pub_area_catalog_id;
                    this.inputDetail.is_read_case = res.bus_json.is_read_case;
                    this.inputDetail.point_ids =
                        res.bus_json.point_ids;
                    this.inputDetail.elec_customer_id =
                        res.bus_json.elec_customer_id;
                }
                this.diaLoading = false;
            });
        },

        /**
         * 获取容量列表
         */
        getCapacitylist(row) {
            api.getCapacitylist({
                elec_customer_account_id: row.elec_customer_account_id
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.model.capacityList = res.bus_json;
                }
                this.diaLoading = false;
            });
        },
        /**
         * 保存用户信息
         */
        saveUserInfo: util.debounce(function(row)  {
            this.$refs["inputDetail"].validate(valid => {
                if (valid) {
                    const loading = this.$loading({
                        lock: true,
                        text: "保存中",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.7)"
                    });
                    let params = {};
                    if (this.dialogTitle !== "新增") {
                        params = {
                            ...this.inputDetail,
                            elec_customer_account_id: this.chooseRow
                                .elec_customer_account_id
                        };
                    } else {
                        params = {
                            ...this.inputDetail,
                            elec_customer_account_id: ""
                        };
                    }
                    api.saveAccount(params).then(res => {
                        if (res && res.error_code === "0") {
                            this.$message({
                                type: "success",
                                message: res.error_msg
                            });
                            this.getAccountList();
                            loading.close();
                            this.dialogStatus = false;
                        } else {
                            loading.close();
                        }
                    });
                } else {
                    return false;
                }
            });
        }, 500),
        /**
         * 删除用户信息
         */
        hanleDelInfo(row) {
            this.chooseRow = row;
            this.$confirm("确定删除这条数据吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    api.delDemoInfo({
                        elec_customer_account_id: row.elec_customer_account_id
                    }).then(res => {
                        if (res && res.error_code === "0") {
                            this.$message({
                                type: "success",
                                message: res.error_msg
                            });
                            if (
                                this.totalNum -
                                (this.pageNum - 1) * this.pageSize ==
                                1
                            ) {
                                this.pageNum =
                                    this.pageNum == 1
                                        ? this.pageNum
                                        : this.pageNum - 1;
                            }
                            this.getAccountList();
                        }
                    });
                })
                .catch(() => { });
        },
        /*  * 新增容量
         */
        addDeviceRow() {
            let time="";
            if(this.model.capacityList.length>0){
               let item= this.model.capacityList[this.model.capacityList.length-1];
                if(undefined!==item){
                    if(item.to_date!=null&&item.to_date!==undefined&&item.to_date!=="Invalid Date"&&item.to_date!==""){
                        time = dayjs(new Date(new Date(item.to_date).getTime()))
                            .add(1, "months")
                            .format("YYYY-MM");
                    }
                }
            }
            const row = {
                from_date: time,
                to_date: "",
                capacity: "",
                status: true
            };
            this.model.capacityList.push(row);
        },
        /*  * 删除容量
         */
        delDeviceInfo(sth) {
            this.model.capacityList.forEach(function (item, index, arr) {
                if (item == sth) {
                    arr.splice(index, 1);
                }
            });
        }
    }
};
</script>
<style lang="scss">
.demo-page-container {
    width: 100%;
    height: 100%;
    padding: px2Rem(20px);
    box-sizing: border-box;

    .el-pagination {
        margin-top: 20px;
    }

    .button-green {
        color: #40be6c;
    }

    .button-red {
        color: #ff8971;
    }

    .button-blue {
        color: #0090e7;
    }

    .el-select {
        width: 100%;
    }

    .search-btn-wrap {
        text-align: right;
    }

    .search-wrap {
        margin-right: 13px;
    }
    .el-form-item__label1 {
        text-align: left;
    }
    .device-dialog-wrap {
        .el-table {
            th {
                padding: 20px 0;
            }
        }
    }

    .add-ele-btn {
        margin-bottom: 20px;
    }
}
.split-line {
    width: 2px;
    height: 12px;
    background: #adadad;
    display: inline-block;
    margin: 0 8px;
    vertical-align: middle;
}
.search-btn-wrap {
    float: right;
    text-align: right;
}

.search-wrap {
    margin-right: 20px;
}
.el-loading-spinner {
    margin-top: -17px;
}    
</style>
